import { render, staticRenderFns } from "./RetirementCalculator.vue?vue&type=template&id=30b9e4c0&scoped=true&"
import script from "./RetirementCalculator.vue?vue&type=script&lang=js&"
export * from "./RetirementCalculator.vue?vue&type=script&lang=js&"
import style0 from "./RetirementCalculator.vue?vue&type=style&index=0&id=30b9e4c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b9e4c0",
  null
  
)

export default component.exports